import router from ".";

import store from "@/store";
import { check_browser } from "@/utils";

// 全局路由拦截
router.beforeEach((to, from, next) => {
  const TOKEN = localStorage.getItem("rypc_token");
  const bro = check_browser();
  console.log("bro", bro, to.path);
  if (to.path.includes("/gaokao")) {
    if (TOKEN) {
      next();
    } else {
      next({
        path: "/login",
        replace: true,
      });
    }
  } else if (to.path === "/login") {
    if (TOKEN) {
      next({
        path: "/gaokao",
        replace: true,
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/** 通过路由钩子 动态渲染每次的title */
router.afterEach((to, from) => {
  if (to.meta.customTit) {
    document.title = to.meta.customTit;
  } else {
    document.title = "标准日本语（日语教材）";
  }
});
